// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"MySelect_my_select_wrapper__uVgLO","my_select":"MySelect_my_select__8sRzz","label":"MySelect_label__4vwJQ"};